import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import get from "lodash/get";

import moment from "moment";

import { getPagedArticles } from "actions/article/article.functions";
import { Loader, Pagination, SEO } from "components";

import { getPage } from "actions/page/page.functions";

import images from "assets/images";

class Blog extends PureComponent {
  state = {
    articlesPerPage: 10,
    currentPage: 1
  };

  getFeaturedImage = item => {};

  componentDidMount() {
    const { dispatch } = this.props;
    const { articlesPerPage, currentPage } = this.state;
    dispatch(getPagedArticles(articlesPerPage, currentPage));
    
    let slug = "blog";
    dispatch(getPage(slug));
  }

  render() {
    const { articles, articlesAreFetching, singlePage } = this.props;

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    if (articlesAreFetching)
      return (
        <div className="loader__container">
          <Loader />
        </div>
      );
    if (!articles && !articlesAreFetching) return null;

    // console.log(articles.better_featured_image);
    // console.log(articles);

    return (
      <main className="view-blog">
        <SEO {...seoProps} />
        <div className="wrapper">
          <div className="view-blog__content">
            <div className="view-blog__heading">
              <h1 className="u-type--beta u-type--primary">Stay connected</h1>
            </div>
            <div className="view-blog__articles">
              <div className="article__list">
                {articles.map(item => (
                  <article className="article__item" key={item.slug}>
                    {item.better_featured_image ? (
                      <div
                        className="article__item__visual"
                        style={{
                          backgroundImage: `url(${
                            item.better_featured_image.source_url
                          })`
                        }}
                      />
                    ) : (
                      <div
                        className="article__item__visual"
                        style={{
                          backgroundImage: `url(${images.blogVisualDefault})`
                        }}
                      />
                    )}
                    <div className="article__item__content">
                      <Link to={`/blog/${item.slug}`}>
                        <h2
                          className="article__item__title u-type--delta u-type--text u-spc-bottom--lrg"
                          dangerouslySetInnerHTML={{
                            __html: item.title.rendered
                          }}
                        />
                      </Link>
                      <div
                        className="article__item__summary u-type--o70"
                        dangerouslySetInnerHTML={{
                          __html: item.excerpt.rendered
                        }}
                      />
                      <div className="article__meta">
                        <span className="article__meta__date">
                          {moment(item.date).format("MMMM DD, YYYY.")}
                        </span>
                        <Link
                          to={`/blog/${item.slug}`}
                          className="article__meta__readmore"
                        >
                          Read more
                        </Link>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
          <Pagination />
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { articles, articlesAreFetching } = state.articles;
  const { singlePage } = state.pages;

  return { articles, articlesAreFetching, singlePage };
};

export default connect(mapStateToProps)(Blog);



// WEBPACK FOOTER //
// ./src/views/Blog.jsx